<template>
    <div class="pt-8">
        <div class="flex w-full lg:w-[90%] mx-auto flex-col lg:flex-row justify-between items-center mb-4">
            <h2 class="font-mulish w-full  mx-auto  text-2xl text-[#053A51] text-left font-bold mb-5">
                Uploaded Promotion Files
            </h2>
        </div>
        <div class="w-full lg:w-[90%] mx-auto rounded-lg py-4 px-0">
            <div class="overflow-x-auto">
                <api-table apiUrl="/staff-promotion/batch" :fields="fields" :show-page="true" :show-search="true"
                    placeholder="Search by name, phone number or email">
                    <template slot="approvalStatus" slot-scope="props">
                        <span v-if="
                            props.rowData.approvalStatus === 'pending'
                        " class="text-gray-500 font-bold">
                            Pending
                        </span>
                        <span v-if="
                            props.rowData.approvalStatus === 'rejected'
                        " class="text-red-500 font-bold">
                            Rejected
                        </span>
                        <span v-if="
                            props.rowData.approvalStatus === 'approved'
                        " class="text-oneGreen font-bold">
                            Approved
                        </span>

                    </template>

                    <template slot="sla" slot-scope="props">
                        <span class="flex justify-center items-center bg-[#DB9D4126] p-2 rounded">
                            <p class="text-[#DB9D41] text-sm font-mulish font-semibold">
                                {{ props.rowData.sla || 'Due for approval in 36h:10m:00s' }}
                            </p>
                        </span>
                    </template>
                    <template slot="action" slot-scope="props">
                        <span class="flex gap-2 justify-end items-center pr-2">
                            <button @click="handleAction('view', props.rowData)"
                                class="px-3 py-1 bg-[#187A33] text-sm font-mulish font-semibold text-[#fff] rounded-md transition">
                                View
                            </button>
                            <button @click="handleAction('download', props.rowData)"
                                class="px-3 py-1 bg-[#F2F9FF] text-sm font-mulish font-semibold border border-[#0090FF] text-[#0090FF] rounded-md transition">
                                Download
                            </button>
                        </span>
                    </template>

                </api-table>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
import { downloadFile } from '@/services/utils';

export default {
    name: "Batch Promotion Record",
    data() {
        return {
            showprogress: true,
            progress: "pending",
            currentPage: 1,
            perPage: 5,
            fields: [
                {
                    name: "id",
                    title: "S/N",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "batchName",
                    title: "Batch Name",
                    titleClass: `text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "createdAt",
                    title: "Date of submission",
                    titleClass: ` text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                    formatter: (val) =>
                        !val ? val : this.moment(val).format("DD-MM-YYYY"),
                },
                {
                    name: "uploaderName",
                    title: "Submitted By",
                    titleClass: ` text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 capitalize pl-4`,
                },
                {
                    name: "approvalStatus",
                    title: "Status",
                    titleClass: ` text-left bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "sla",
                    title: "SLA Countdown",
                    titleClass: `text-center bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
                {
                    name: "action",
                    title: "Action",
                    titleClass: ` text-center bg-[#DEFFDE] py-3 pl-4 `,
                    dataClass: `text-left py-2 pl-4`,
                },
            ],
        };
    },
    computed: {
        progressText() {
            switch (this.progress) {
                case "pending": return "Batch under review";
                case "in-progress": return "Pending review";
                case "failed": return "Expired batch review";
                default: return "";
            }
        },
        progressSubText() {
            switch (this.progress) {
                case "pending": return "We’ll let you know within 72h:35m:05s";
                case "in-progress": return "36h:15m:00s left to review pending batches";
                case "failed": return "Pending batches were not reviewed within time frame";
                default: return "";
            }
        },
    },

    methods: {
        mapStatus(apiStatus) {
            switch (apiStatus) {
                case "successful":
                    return "Approved";
                case "rejected":
                    return "Rejected";
                case "pending":
                    return "Pending";
                default:
                    return apiStatus;
            }
        },

        async handleAction(action, batch) {
            switch (action) {
                case "download":
                    await downloadFile(batch.batchExcelFile, `${batch.batchNo}.xlsx`);
                    break;
                case "view":
                    router.push(`/admin/promotion/batch-records/${batch._id}`);
                    break;
                default:
                    console.log("Unknown action:", action);
            }
        }
    },
};
</script>